import React, { FC, useContext, useMemo } from 'react';

import { EvIcon } from '@evinced-private/ui-common';

import CalendarIcon from './assets/Calendar.svg?raw';
import { calculateNextScheduledDate } from './helpers/calculateNextScheduledDate';
import { SchedulingSectionContext } from './context';
import { schedulingLabels } from './labels';

import './SchedulingSection.scss';

export const NextScanDate: FC = () => {
	const { config } = useContext(SchedulingSectionContext);

	const date = useMemo(() => {
		const nextDate = config ? calculateNextScheduledDate(config) : null;
		return nextDate ?? new Date();
	}, [config]);

	const formattedDate = date.toLocaleDateString(undefined, {
		year: 'numeric',
		month: 'long',
		day: 'numeric',
		weekday: 'long'
	});
	const formattedTime = date.toLocaleTimeString(undefined, {
		hour: 'numeric',
		minute: '2-digit',
		hour12: true
	});

	return (
		<div className="next-scan-date-container">
			<EvIcon className="scheduling-section-footer-icon" icon={CalendarIcon} />

			<span className="next-scan-date">
				{schedulingLabels.nextScanScheduledFor} <strong>{formattedDate}</strong>
				{schedulingLabels.at}
				<strong>{formattedTime}</strong>
			</span>
		</div>
	);
};
